import defaultColor from "@/components/color";
const dataText = JSON.stringify([
    {
        group:'广州机房',
        type:'line',
        unit:'℃',
        data:[
            {name:'Mon',value:180},
            {name:'Tue',value:200},
            {name:'Wed',value:190},
            {name:'Thu',value:180},
            {name:'Fri',value:170},
            {name:'Sat',value:190},
        ]
    }, {
        group:'深圳机房',
        type:'bar',
        unit:'℃',
        data:[
            {name:'Mon',value:200},
            {name:'Tue',value:220},
            {name:'Wed',value:170},
            {name:'Thu',value:160},
            {name:'Fri',value:270},
            {name:'Sat',value:190},
        ]
    }, {
        group:'关系3',
        type:'bar',
        unit:'人',
        data:[
            {name:'Mon',value:1200},
            {name:'Tue',value:1220},
            {name:'Wed',value:1170},
            {name:'Thu',value:1160},
            {name:'Fri',value:1270},
            {name:'Sat',value:1190},
        ]
    }
])

export default {
    attribute:{
        color: defaultColor,
        title: {
            text: '',
            left: '20',
            top: 'top',
            textStyle: { fontSize: 18, color: '#ccc' }
        },
        legend: {
            show: true,
            orient: 'horizontal',
            x: 'center',
            y: 'bottom',
            textStyle:{
                color: '#6aa9e4',
                fontSize: 12
            }
        },
        grid:{
            x:10,y:60,x2:40,y2:30,containLabel: true
        },
        xAxis: {
            show: true,
            type: 'category',
            name: '',
            axisLabel:{
                show: true,
                color: '#6aa9e4',
                fontSize:12,
                rotate:0
            },
            axisLine:{
                show: true,
                lineStyle: {
                    color: '#02438e'
                }
            },
            axisTick:{//x轴刻度线
                show: false,
            },
            
            splitLine: {//网格线
                show: false
            },
        },
        yAxis:{
            show: true,
            axisTick:{//x轴刻度线
                show: false,
            },
            axisLabel:{
                fontSize: 13,
                color: '#6aa9e4',
                rotate:0,
                yColors: []
            },
            axisLine:{
                show: false
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: ['#14477e', '#14477e']
                }
            }
        },
        series:{
            showBackground: false,
            borderRadius: 0,
            smooth: true,
            label: {
                show: false, //数值
                position: 'top',
                color: '#14477e',
                fontSize: 13,
                unit: true
            },
            barWidth:20
        },
        tooltip: {
            trigger: 'item',
            backgroundColor: 'rgba(0,0,0,0.5)',
            textStyle: {
                color: "#fff",
            },
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
                type: 'shadow',       // 默认为直线，可选为：'line' | 'shadow'
            }
        },
        dataZoom: {show: false,height:15},
        cptTableData:[
            { "name": "分组", "value": "", "namekey": "group" },
            { "name": "类型", "value": "", "namekey": "type" },
            { "name": "单位", "value": "", "namekey": "unit" },
            { "name": "维度", "value": "", "namekey": "name" },
            { "name": "指标", "value": "", "namekey": "value" },
        ]
    },
    cptDataForm:{dataText: dataText,dataSource: 1, pollTime: 0},
}
